import React, { useEffect, useRef } from 'react';
import './Modal.css';
import { useMap } from 'react-leaflet';
import {ReactComponent as CloseIcon} from '../../assets/img/controls/close.svg';

export type ModalSize = 'small' | 'medium' | 'large';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  size?: ModalSize;
  className?: string;
  title: string;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  title,
  size = 'small',
  className = ''
}) => {
  const map = useMap();
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    toggleMapInteraction(!isOpen);
    const handleEscKey = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = '';
      map.scrollWheelZoom.enable();
      map.dragging.enable();
    };
  }, [isOpen, onClose, map]);

  const toggleMapInteraction = (enable: boolean) => {
    if (!map) return;

    if (enable) {
      map.scrollWheelZoom.enable();
      map.dragging.enable();
    } else {
      map.scrollWheelZoom.disable();
      map.dragging.disable();
    }
  };


  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div 
        ref={modalRef}
        className={`modal modal-${size} ${className}`}
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-header">
          {title && <h2 className="modal-header_title">{title}</h2>}
          <button
            onClick={onClose}
            className="modal-header_close-button"
            aria-label="Close modal"
          >
            <CloseIcon className={'icon'}></CloseIcon>
          </button>
        </div>
        <div className="modal__content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;